var app_popup = null;

(function($) {
	"use_strict";

	app_popup = function(_app) {
		var self = this;
		var app = _app;
		var settings = app.settings;
		var element = $("#hoverpop");
		var timeOut;
		var mouse_position_x;
		var mouse_position_y;

		/**
		 * init
		 * @returns {undefined}
		 */
		self.init = function() {
			$(window).on("mousemove", self.mousemove);
		};

		self.setElemet = function() {
			element = $("body").find("#hoverpop");
		};

		

		/**
		 * Show pop up
		 * @param {Object} data
		 * @returns {undefined}
		 */
		self.showPopUp = function(data) {
			self.setElemet();

			// console.log(data); 

			var htmlString = "";

			if (data) {

				// console.log(data);

				htmlString += "<h4 class='has-text'>" + data.name + "</h4>";

				if ("" !== data.descriptionShort) {
					htmlString += "<p>" + data.descriptionShort + "</p>";
				}

				//Build Left,
				htmlString += '<ul>';

				if (data.floor > 0) {
					htmlString += "<li><span>Etasje:</span>" + data.floor + "</li>";
				}

				if (data.rooms.length > 0) {
					htmlString += "<li><span>Soverom:</span>" + data.roomsDisplay + "</li>";
				}

				if (data.bi_size) {
					if(data.bi_size > 0){
						htmlString += "<li><span>BRA - i m2:</span>" + data.bi_size.replace(".", ",") + " m²</li>";
					}else{
						htmlString += "<li><span>BRA - i m2:</span> - </li>";
					}
				}

				if (data.size.length > 0) {
					if(data.size > 0){
						htmlString += "<li><span>BRA - e m2:</span>" + data.size.replace(".", ",") + " m²</li>";
					}else{
						htmlString += "<li><span>BRA - e m2:</span> - </li>";
					}
				}

				if (data.total_bra.length > 0) {
					if(data.total_bra > 0){
						htmlString += "<li><span>Total BRA m2:</span>" + data.total_bra.replace(".", ",") + " m²</li>";
					}else{
						htmlString += "<li><span>Total BRA m2:</span> - </li>";
					}
				}

				if (data.yard_size.length > 0) {
					if(data.yard_size > 0){
						htmlString += "<li><span>TBA:</span>" + data.yard_size.replace(".", ",") + " m²</li>";
					}else{
						htmlString += "<li><span>TBA:</span> - </li>";
					}
				}

				if (data.p_space >= 0) {
					htmlString += "<li><span>Parkering:</span>" + data.p_space + "</li>";
				}

				if (data.price > 0) {
					var p = addCommas(data.price, data.available);
					htmlString += "<li><span>Pris:</span>" + (p == ' - ' ? p : p  + " kr ") + "</li>";
				}
				
				htmlString += "</ul>";

				htmlString += "<div class='status " + data.available + "'>";
				
				var status = app.statusTranslate(data.available);

				if (status === "Ledig" && (data.name.indexOf('H03') === 0 || data.name.indexOf('H01') === 0 || data.name.indexOf('H02') === 0)){
					status = "Innflytningsklar";
				}

				htmlString += status;
				htmlString += "</div>";

				if ($(window).outerWidth() < 768) {
					//htmlString += '<a href="'+data.url+'">Läs mer</a>';
				}
			} else {
				htmlString += "<h4>Ikke tilgjengelig</h4>";
			}
			element.html(htmlString);
			element.css({ display: "block", opacity: 1 });
			clearTimeout(timeOut);

			

		};

		/**
		 * Showpopup info
		 * @param {int} id
		 * @returns {undefined}
		 */
		self.showPopUpInfo = function(id) {



			self.setElemet();

			var htmlString = "";
			var data = self.get_info(id);

			if (data) {

				if(data.text != ""){
					htmlString += "<h4 class='has-text'>" + data.rubrik + "</h4>";
				}else{
					htmlString += "<h4>" + data.rubrik + "</h4>";
				}
				

				//Build Left,
				htmlString += '<div class="text">';
				htmlString += data.text;

				if(data.id){
					var co = 0;
					app.houses.forEach(function(house){
						if(house.name == data.id){
							co = house.count;
						}
					});

					if(co === 0){
						if (id != "info_house_2"){
							htmlString += '<br><span class="count"><strong>Utsolgt</strong></span>';
						}
					}else{
						if (co === 1){
							// htmlString += '<br><span class="count"><strong>' + co + ' Ledig</strong></span>';
							htmlString += '<br><span class="count"><strong>Kun en leilighet igjen</strong></span>';
						}else{
							htmlString += '<br><span class="count"><strong>' + co + ' Ledige</strong></span>';
						}
					}
				}
				htmlString += "</div>";
			} else {
				htmlString += "<h4>Ikke tilgjengelig</h4>";
			}

			element.html(htmlString);
			element.css({ display: "block", opacity: 1 });

			clearTimeout(timeOut);

			
		};

		/*
		 * Hide popup
		 */
		self.hidePopUp = function() {

			

			self.setElemet();
			element.css({'opacity': 0});
			timeOut = setTimeout(function () {
			    element.hide();
			}, 1);
		};

		/**
		 * Get info
		 * @param {int} id
		 * @returns {settings.info|Boolean}
		 */
		self.get_info = function(id) {
			if (!undef(settings.info) && !undef(settings.info[id])) {
				return settings.info[id];
			}
			return false;
		};

		/**
		 * Mouse move funtion
		 * @param {type} event
		 * @returns {undefined}
		 */
		self.mousemove = function(event) {
			self.setElemet();
			mouse_position_x = event.pageX;
			mouse_position_y = event.pageY;
			var extraLeft = 0;
			var extraTop = 0;
			var ww = $(window).outerWidth();
			
			var views = $("body").find(".views");

			if (mouse_position_x < ww / 2) {
				extraLeft = 80;
			} else {
				extraLeft = -280;
			}
			if (mouse_position_y < ww / 2) {
				extraTop = 20;
			} else {
				extraTop = 20;
			}

			if (views.length > 0) {
				var ll = mouse_position_x + extraLeft - parseInt(views.offset().left);

				if (ww > 768) {
					element.css({
						left: ll,
						top: mouse_position_y + extraTop - parseInt(views.offset().top) - 20
					});
				} else {

					extraTop = 40;

					if (ll < 0) {
						element.css({
							left: 0,
							top:
								mouse_position_y + extraTop - parseInt(views.offset().top) - 20
						});
					} else {
						element.css({
							left: 0,
							top:
								mouse_position_y + extraTop - parseInt(views.offset().top) - 20
						});
					}
				}
			}
		};

		self.init();

		return self;
	};
})(jQuery);
